<template>
  <div class="sidebar">
    <div v-if="active" class="sidebar-backdrop" @click="SET_ACTIVE(false);"></div>
    <transition name="slide">
       <div v-if="active" class="sidebar-panel">
         <slot></slot>
       </div>
    </transition>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
export default {
  name:"SidebarBirth",
  computed: {
    ...mapState("sidebar", ["active"])
  },
  methods:{
    ...mapMutations("sidebar", ["SET_ACTIVE"]),
  }
}
</script>